// extracted by mini-css-extract-plugin
export default {"overlay":"overlay_overlay__l1g6N"};